import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class SmsCodeForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    static propTypes = {
        texts: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired
    };

    _onChange(event) {
        this.setState({value: event.target.value});
    }

    _onSubmit(event) {
        event.preventDefault();
        this.props.handleSubmit(this.state.value);
        this.setState({value: ''});
    }

    render() {
        let value = this.state.value;
        console.log("SMS FORM");
        return (
            <form onSubmit={this._onSubmit.bind(this)}>
                <div className="form-group">
                    <label>{this.props.texts.label_smscode}</label>
                    <div className="input-group">
                            <span className="input-group-addon" id="basic-addon1">
                                <span className="glyphicon glyphicon-hand-right" aria-hidden="true"></span>
                            </span>
                        <input type="text" value={value}
                               className="form-control input-lg"
                               placeholder={this.props.texts.placeholder_smscode}
                               onChange={this._onChange.bind(this)}
                        />
                    </div>
                </div>
                <input type="submit" value={this.props.texts.submit} className="btn btn-default"/>
            </form>
        );
    }
}
